import React, { useMemo, useState, useEffect } from 'react';
import { Button, Stack, Typography, Grid, Tooltip, Menu, MenuItem, IconButton, Box, TextField, Paper, Avatar, } from '@mui/material';
import OZDataGrid from "../../../components/admin/common/OZDataGrid/OZDataGrid";
import OZGridToolbar from "../../../components/admin/common/OZDataGrid/OZGridToolbar";
import LoadingScreen from "../../../components/admin/common/OZLoadingScreen/OZLoadingScreen";
import AddBoxOutlinedIcon from '@mui/icons-material/AddBoxOutlined';
import { deletePlanById, getPlanById, getPlans, getUsersAssignedToPlan } from "../../../services/api-service";
import AddPlans from "./AddPlansForm";
import './Plans.css';
import { showErrorNotification, showSuccessNotification } from '../../../components/admin/common/NotiService';
import DeleteDialog from '../../../components/admin/common/CustomDeleteDialog';
import { ADMIN_FORM_MODES } from '../../../utils/constants';
import CopyPlanForm from './CopyPlanForm';
import OZDialog from '../../../components/admin/common/OZDialog';
import LaunchIcon from '@mui/icons-material/Launch';
import { Virtuoso } from 'react-virtuoso';
import { Search } from '@mui/icons-material';
import { writeAccess } from '../../../services/page-service';

function Plans() {

  const [planForm, setPlanForm] = useState(false);
  const [mode, setMode] = useState(null);
  const [planList, setPlanList] = useState([]);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [loading, setLoading] = useState(false);
  const [gridRef, setGridRef] = useState(null);

  useEffect(() => {
    getPlansList();
  }, []);

  let buttonStyle = useMemo(() => ({ borderRadius: '8px', height: '30px', fontSize: '14px', fontWeight: 400 }), []);

  const GetNameRenderer = (props) => {
    return (
      // <Tooltip title={(props?.data?.name) ? props?.data?.name : ''}>
      <span style={{ color: "#3D8BF8", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden", cursor: 'pointer' }}>{props.value}</span>
      // </Tooltip>
    );
  };

  const DateRenderer = (props) => {
    const anchorRef = React.useRef();
    const [deleteMenuAnchor, setDeleteMenuAnchor] = useState(false);
    const [openDelete, setOpenDelete] = useState(false);
    const [openCopy, setOpenCopy] = useState(false);


    const onMorevertIconClick = () => {
      setTimeout(() => setDeleteMenuAnchor(anchorRef?.current), 1);
    };

    const handleCloseDeleteMenu = () => {
      setDeleteMenuAnchor(false);
    };

    function onClickDelete(e) {
      setDeleteMenuAnchor(false);
      setOpenDelete(true)
    }

    function onClickCopy(e) {
      setDeleteMenuAnchor(false);
      setOpenCopy(true)
    }

    const styleListItemButton = useMemo(
      () => ({
        "&.MuiButtonBase-root": {
          color: '#212121',
          fontFamily: "Roboto",
          fontSize: "12px",
          fontWeight: 400,
          height: '16px',
          lineHeight: "14px",
        },
        '&:hover': {
          borderRadius: "4px",
        },
      }),
      []
    );

    const date = new Date(props.data.createdDate);
    const options = { day: 'numeric', month: 'short', year: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' };

    return (
      <div className='oz-user-Status-container'>
        <label>{date.toLocaleString("en-GB", options)}</label>
        {writeAccess() && <img className="userMorevertIcon"
          onClick={onMorevertIconClick}
          src={`${process.env.PUBLIC_URL}/icons/more_vert.svg`} alt="edit"
        >
        </img>}
        <div ref={anchorRef}>
          <Menu anchorEl={deleteMenuAnchor} open={Boolean(deleteMenuAnchor)} onClose={handleCloseDeleteMenu} sx={{
            "& .MuiPaper-root": {
              backgroundColor: "#FFFFFF",
              width: "133px",
              minHeight: "35px",
            },
            "& .MuiMenu-paper": {
              backgroundColor: "#FFFFFF",
              boxShadow: "0rem 0.25rem 0.75rem rgba(0, 0, 0, 0.04)",
              border: "0.0625rem solid #E6E5E6",
              borderRadius: "12px",
              marginLeft: "-0.3625rem",
              marginTop: "0rem",
            },
          }}>
            <MenuItem onClick={onClickDelete} sx={{ ...styleListItemButton, marginTop: "2px" }}>Delete</MenuItem>
            <MenuItem onClick={onClickCopy} sx={{ ...styleListItemButton, marginTop: "3px" }}>Make a Copy</MenuItem>
          </Menu>
          {openDelete && <DeleteDialog
            open={openDelete}
            onClose={() => { setOpenDelete(false) }}
            title={"Delete Plan"}
            content={`This will delete (${props.data.name}) Plan permanently. You cannot undo this action.`}
            deleteFunction={() => deletePlan(props.data)} />}

          {openCopy && <CopyPlanForm
            props={props?.data}
            onClose={() => { setOpenCopy(false); localStorage.removeItem("copyPlanForm") }}
            updateFunction={getPlansList}
          />
          }
        </div>
      </div>
    );
  };

  const UsersRenderer = (props) => {
    const [showDialog, setDialog] = useState(false);
    const [usersInPlan, setUserDetails] = useState([]);
    const closeAdminEditForm = () => {
      setDialog(false);
    }

    const [searchTerm, setSearchTerm] = useState('');

    const filteredItems = useMemo(() => {
      try {
        if (!searchTerm) return usersInPlan;
        return usersInPlan.filter(item =>
          item.username.toLowerCase().includes(searchTerm.toLowerCase())
        );
      } catch (error) {
        console.error("Error filtering items:", error);
        return usersInPlan;

      }
    }, [usersInPlan, searchTerm]);


    const getUsersInPlan = () => {
      try {
        getUsersAssignedToPlan(props.data.id)
          .then((resp) => {
            if (resp?.Status === 'Success') {
              setDialog(true);
              setUserDetails(resp?.Data || []);
            } else {
              showErrorNotification("Error getting Users in this Plan");
            }
          })
          .catch((e) => {
            showErrorNotification("Error getting Users in this Plan");
          });
      } catch (error) {
        showErrorNotification("Error getting Users in this Plan");
        console.error("Error fetching users in plan:", error);
        setUserDetails([]);
        setDialog(false);
      }
    }

    return (
      <>
        <div >
          <Stack direction={'row'} >
            <span style={{ width: '20px', color: '#00000' }}>{props.value}</span>
            <Tooltip title="View Users in this Plan">
              <IconButton onClick={getUsersInPlan} size='small' disabled={props.value === 0} >
                <LaunchIcon fontSize='3px' />
              </IconButton>
            </Tooltip>
          </Stack>

        </div>

        {showDialog && <OZDialog
          title={`Users in  ${props.data.name} Plan`}
          hideActions={true}
          open={showDialog}
          onClose={closeAdminEditForm}
        >
          <Box>
            <TextField
              fullWidth
              size='small'
              placeholder=" Search Users..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              variant="outlined"
              sx={{
                mb: 1,
                '& .MuiOutlinedInput-root': {
                  borderRadius: 2,
                  '&:hover fieldset': {
                    borderColor: 'primary.main',
                  },
                  '&.Mui-focused fieldset': {
                    borderColor: 'primary.main',
                  },
                },
              }}
              InputProps={{
                startAdornment: <Search sx={{ color: 'text.secondary', mr: 1 }} />
              }}
            />

            <Paper
              sx={{
                height: 410,
                width: 370,
                borderRadius: 2,
                overflow: 'hidden',
                boxShadow: 1
              }}
            >
              {filteredItems.length === 0 ? (
                <Box
                  sx={{
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: 'text.secondary',
                    gap: 2
                  }}
                >
                  <Search sx={{ fontSize: 48, opacity: 0.5 }} />
                  <Typography variant="body1" sx={{ fontSize: 16, fontWeight: 500 }}>
                    No users found
                  </Typography>
                  {searchTerm && (
                    <Typography variant="body2" sx={{ fontSize: 14, textAlign: 'center', px: 2 }}>
                      Try adjusting your search term
                    </Typography>
                  )}
                </Box>
              ) : (
                <Virtuoso
                  style={{ height: '100%' }}
                  totalCount={filteredItems.length}
                  itemContent={(index) => (
                    <Box
                      sx={{
                        maxWidth: '98%',
                        p: 1.5,
                        borderBottom: '1px solid',
                        borderColor: 'grey.100',
                        bgcolor: 'white',
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1.5,
                        cursor: 'pointer',
                        transition: 'all 0.2s ease',
                        '&:hover': {
                          bgcolor: 'grey.50',
                          transform: 'translateX(4px)',
                        }
                      }}
                    >
                      <Avatar
                        sx={{
                          bgcolor: 'primary.main',
                          color: 'white',
                          width: 24,
                          height: 24,
                          fontSize: 14
                        }}
                      >
                        {filteredItems[index]?.username.charAt(0).toUpperCase()}
                      </Avatar>

                      <Box sx={{ flex: 1 }}>
                        <Typography
                          variant="body1"
                          sx={{
                            fontSize: 14,
                            fontWeight: 500,
                            color: 'text.primary',
                            mb: 0.5
                          }}
                        >
                          {filteredItems[index]?.username}
                        </Typography>
                      </Box>
                    </Box>
                  )}
                />
              )}
            </Paper>
          </Box>
        </OZDialog>
        }
      </>
    );
  };

  const columnDefs = [
    { field: 'name', headerName: 'Plan Name ', enableRowGroup: false, cellRenderer: GetNameRenderer },
    { field: 'usersCount', headerName: 'Users', cellRenderer: UsersRenderer },
    { field: 'usersAssigned', headerName: 'Users Assigned', cellRenderer: GetNameRenderer, hide: true },
    { field: 'createdDate', headerName: 'Created Date', cellRenderer: DateRenderer },
  ];

  const showAddPlanForm = () => {
    setPlanForm(true);
    setMode(ADMIN_FORM_MODES.add);
  };

  const closeAddPlanForm = () => {
    setPlanForm(false);
  };

  async function onClickRow(rowItem) {
    setLoading(true);
    let id = rowItem.data.id;
    try {
      await getPlanById(id)
        .then((resp) => {
          if (resp?.Status === 'Success') {
            setSelectedPlan(resp?.Data || {});
            setPlanForm(true);
            setMode(ADMIN_FORM_MODES.view)
          } else {
            setSelectedPlan({});
            showErrorNotification("Error getting Selected Plan");
          }
        })
        .catch((e) => {
          setSelectedPlan({});
          showErrorNotification("Error getting Selected Plan");
        });
    } catch (e) {
      showErrorNotification("Error getting Selected Plan");
      setSelectedPlan({});
    }
    setLoading(false);;
  }

  async function deletePlan(data) {
    setLoading(true);
    try {
      await deletePlanById(data?.id)
        .then((resp) => {
          if (resp?.Status === "Success") {
            showSuccessNotification(`Plan ${data.name} Deleted Successfully`)
            getPlansList();
          }
          else {
            showErrorNotification(resp?.Message?.name || resp?.Message?.description || resp?.Message || "Failed to delete the Plan");
          }
        })
        .catch((e) => {
          showErrorNotification("Failed to delete the Plan");

        });
    } catch (e) {
      showErrorNotification(JSON.stringify(e));
    }
    setLoading(false);
  }

  async function getPlansList() {
    setLoading(true);
    try {
      await getPlans()
        .then((resp) => {
          setPlanList(resp.Data);
        })
        .catch((e) => {
          setPlanList([]);
        });
    } catch (e) {
      showErrorNotification("Error in users list");
      setPlanList([]);
    }
    setLoading(false);
  };

  async function downloadPlansList() {
    try {
      return await getPlans(true)
        .then((resp) => {
          return resp.Data;
        })
        .catch((e) => {
          return [];
        });
    } catch (e) {
      showErrorNotification("Error in users list");
      return [];
    }
  };

  return (
    <div>
      {!planForm && (
        <div className="ozAdminUsersContainer">
          <Grid sx={{ marginBottom: "10px" }}>
            <Typography className='oz-page-header'> People </Typography>
          </Grid>
          <Stack direction="row" sx={{ marginBottom: "16px" }} justifyContent="space-between">
            <Typography className='oz-page-heading'> Plans </Typography>
            {/* {localStorage.getItem('parentUser') === 'null' &&
              <Button
                sx={buttonStyle}
                variant="contained"
                startIcon={<AddBoxOutlinedIcon />}
                onClick={showAddPlanForm}
              >
                Add Plan
              </Button>
            } */}
            {writeAccess() && <Button
              sx={buttonStyle}
              variant="contained"
              startIcon={<AddBoxOutlinedIcon />}
              onClick={showAddPlanForm}
            >
              Add Plan
            </Button>}
          </Stack>
          <OZGridToolbar
            title='List of Plans'
            searchPlaceholder='Plan Name'
            rowCount={planList.length}
            dataGridRef={gridRef}
            fileName='Plans'
            downloadBlockNumber={true}
            downloadBlockNumberFunc={downloadPlansList}
          // showFilters={true}
          // filtertProps={{ column: 'enabled', options: [{ Active: true }, { Deactivated: false }] }} 
          />
          <OZDataGrid height="26.3rem" columns={columnDefs} data={planList} rowClickCallback={onClickRow} setGridRef={setGridRef} />
          {loading &&
            <div style={{ position: 'fixed', top: '0', left: '0', width: '100%', height: '100%', backgroundColor: '0,0,0,0.5', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000 }} >
              <LoadingScreen />
            </div>
          }
        </div >
      )}
      {planForm && (
        <>
          {loading ?
            (
              <div style={{ position: 'fixed', top: '0', left: '0', width: '100%', height: '100%', backgroundColor: '0,0,0,0.5', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000 }} >
                <LoadingScreen />
              </div>
            ) :
            (
              <>
                <AddPlans hideAgent={false} onClose={closeAddPlanForm} mode={mode} updateFunction={getPlansList} rowData={selectedPlan} />
              </>
            )
          }
        </>
      )}
    </div>
  );
}
export default Plans;